import state from './comfort.state'
import mutations from './comfort.mutations'
import actions from './comfort.actions'

export default {
  state,
  mutations,
  actions
}
